import { Outlet } from 'react-router-dom';
import useCreateEditProjectLayout from './use-create-edit-project-layout';
import { selectFeatureFlags } from '@/store/slices/feature-flags/selectors';
import { useAppSelector } from '@/store/hooks';
import { FeatureFlagsEnum } from '@/store/slices/feature-flags/types';

const ProjectRoot = () => {
  const flags = useAppSelector(selectFeatureFlags);

  const isProjectDetailsAvailable = flags[FeatureFlagsEnum.project_details];

  useCreateEditProjectLayout({ preventUpdate: !isProjectDetailsAvailable });

  return <Outlet />;
};

export default ProjectRoot;
